import { render, staticRenderFns } from "./RegisterBrandModal.vue?vue&type=template&id=1620acae&scoped=true&lang=pug"
import script from "./RegisterBrandModal.vue?vue&type=script&lang=js"
export * from "./RegisterBrandModal.vue?vue&type=script&lang=js"
import style0 from "./RegisterBrandModal.vue?vue&type=style&index=0&id=1620acae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1620acae",
  null
  
)

export default component.exports